import React, {Component} from 'react';
import {withStyles} from "@material-ui/core";
import CardMedia from "@material-ui/core/CardMedia";
import Card from "@material-ui/core/Card";


class ImageViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // width: this.props.width,
            // height: this.props.height,
        };


        // if (this.props.doResize) {
        //     this.props.doResize((width, height) => {
        //         this.setState({width, height});
        //     })
        // }
    }

    // componentDidMount() {
    //     this._updateIframe();
    // }
    //
    // componentDidUpdate() {
    //     this._updateIframe();
    // }
    //
    //
    // _updateIframe() {
    //     const document = this.iFrame.current.contentDocument;
    //     if (this.pageBefore !== this.state.pageNumber && this.state.sheets && this.state.sheets.length > this.state.pageNumber - 1) {
    //         this.pageBefore = this.state.pageNumber;
    //         document.body.innerHTML = '';
    //         document.write(this.state.sheets[this.state.pageNumber - 1]);
    //     }
    //     this.iFrame.current.width = this.state.width;
    //     this.iFrame.current.height = this.state.height;
    // }

    render() {
        const {classes} = this.props;
        return (
            <CardMedia
                image={this.props.filename}
                component={"img"}
                title=""
                style={{
                    maxHeight: this.state.height,
                    maxWidth: this.state.width,
                }}
            />
        );
    }
}


const styles = theme => ({});


export default withStyles(styles)(ImageViewer);
